module.exports = __webpack_public_path__ + "img/bg-GuoJiao.f5b448fc.png";